
































































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import TaskService from '@/domain/task/task.service';
import Task from '@/domain/task/task.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ContractService from '@/domain/contract/service/contract.service';
import CalculationService from '@/domain/calculation/service/calculation.service';
import { BillingType } from '@/shared/utils/billing-type.enum';
import getPastMonth from '@/shared/utils/get-past-month';
import CalculationResult from '@/domain/calculation/entity/calculation-result.entity';
import ContractItemExchangeCurrency from '@/domain/contract/entity/contract-item-exchange-currency.entity';
import LogComponent from '@/shared/log/log.component.vue';
import PerformBillingConfirmSingleModal from './perform-billing-confirm-single-modal.component.vue'
import PerformBillingInfoModal from './perform-billing-info-modal.component.vue'
import PerformBillingModalFields from './perform-billing-modal-fields.component.vue';

@Component({
  components: {
    PerformBillingConfirmSingleModal,
    PerformBillingInfoModal,
    PerformBillingModalFields,
    LogComponent,
  },
})
export default class PerformBillingModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
  })
  simulation!: boolean;

  @Prop({
    required: true,
  })
  showLog!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
  })
  objectId!: string;

  @Prop({ type: Boolean, default: false })
  billingDaily!: boolean;

  @Prop({
    required: false,
  })
  currency?: ContractItemExchangeCurrency;

  @Prop({
    required: false,
    default: () => CalculationResult.of({}),
  })
  calculationResult!: CalculationResult;

  competences: string[] = [];

  invoiceCompetence: string = '';

  pickerMenu: boolean = false;

  invoicePickerMenu: boolean = false;

  loading: boolean = false;

  executionId: string = '';

  executionType: string = BillingType.SINGLE;

  showModalConfirmSingle: boolean = false;

  showModalSingleBillingInfo: boolean = false;

  startDate: string = '';

  endDate: string = '';

  created() {
    this.setPastMonthCompetence();
    this.invoiceCompetence = getPastMonth();
  }

  get isSingle() {
    return this.executionType === BillingType.SINGLE;
  }

  get modalState() {
    return this.showModal;
  }

  set modalState(value: boolean) {
    this.$emit('updateModalState', value);
  }

  setPastMonthCompetence(): void {
    this.competences = [getPastMonth()];
  }

  startLoading(): void {
    this.loading = true;
  }

  stopLoading(): void {
    this.loading = false;
  }

  handleupdateModalConfirmSingleExecution() {
    this.showModalConfirmSingle = false;
  }

  handleBillingAction() {
    return this.simulation ? this.handleSimulationExecution()
      : this.handleBillingExecution();
  }

  handleSimulationExecution() {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    if (this.isSingle) {
      this.simulateBilling();
    } else {
      this.simulateRetroactiveBilling();
    }
  }

  handleBillingExecution() {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    if (this.isSingle) {
      this.handleInvoiceExists();
    } else {
      this.executeRetroactiveBilling();
    }
  }

  handleConfirmSingleExecution(): void {
    this.showModalConfirmSingle = false;
    if (this.isSingle) {
      this.checkPreInvoiceExists();
    } else {
      this.executeRetroactiveBilling();
    }
  }

  private handleInvoiceExists() {
    ContractService
      .existsInvoiceItem(this.objectId, this.invoiceCompetence)
      .then((existsInvoice: boolean) => {
        this.showModalConfirmSingle = existsInvoice;
        if (!existsInvoice) {
          this.executeBilling();
        }
      });
  }

  private checkPreInvoiceExists() {
    ContractService
      .existsPreInvoiceItem(this.objectId, this.invoiceCompetence)
      .then((existsPreInvoice: boolean) => {
        this.showModalConfirmSingle = false;
        if (!existsPreInvoice) {
          this.executeBilling();
        } else {
          this.showModalSingleBillingInfo = existsPreInvoice;
        }
      });
  }

  handleUpdateModalBillingInfo() {
    this.showModalSingleBillingInfo = false;
  }

  executeBilling(): void {
    this.startLoading();
    ContractService
      .performSingleBilling({
        businessUnitId: this.businessUnitId,
        contractItemId: this.objectId,
        invoiceCompetence: this.invoiceCompetence,
      })
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch((err) => this.handleError(err));
  }

  simulateBilling(): void {
    this.startLoading();
    CalculationService
      .simulate(this.businessUnitId, this.objectId, this.invoiceCompetence)
      .then((response: any) => this.handleSimulationSuccess(response))
      .catch((err: any) => this.handleSimulationError(err));
  }

  simulateRetroactiveBilling(): void {
    this.startLoading();
    this.fillRetroactiveDates();
    CalculationService
      .simulateRetroactive(this.businessUnitId, this.objectId,
        this.competences.join(','),
        this.invoiceCompetence,
        this.startDate,
        this.endDate)
      .then((taskId: string) => this.handleSimulationSuccess(taskId))
      .catch((err) => this.handleSimulationError(err));
  }

  fillRetroactiveDates(): void{
    if (this.startDate === '') {
      this.startDate = this.competences[0];
    }

    if (this.endDate === '') {
      this.endDate = this.competences[this.competences.length - 1];
    }
  }

  private handleSimulationSuccess(taskId: string) {
    TaskService.getTask(taskId, 2000)
      .then((task: Task) => {
        this.calculationResult = CalculationResult.of(task.payload);
        this.stopLoading();
        this.showLog = true;
      })
      .catch((err) => this.handleSimulationError(err))
  }

  private handleSimulationError(err: any) {
    this.stopLoading();
    VbSnackbarService.handleHttpError(err);
  }

  executeRetroactiveBilling(): void {
    this.startLoading();
    this.fillRetroactiveDates();

    ContractService
      .performRetroactiveBilling(this.businessUnitId, this.objectId,
        this.competences.join(','),
        this.invoiceCompetence,
        this.startDate,
        this.endDate)
      .then((taskId: string) => this.handleExecuteBilling(taskId))
      .catch((err) => this.handleError(err));
  }

  private handleExecuteBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => this.handleExecutionSuccess())
      .catch((err) => this.handleError(err));
  }

  private handleExecutionSuccess() {
    this.modalState = false;
    this.stopLoading();
    this.$emit('executionSuccess');
  }

  private handleError(err: any) {
    this.stopLoading();
    VbSnackbarService.handleHttpError(err);
    if (err && err.cause && err.cause.endsWith('PerformBillingAutomationBlockException')) {
      return;
    }
    this.$emit('executionError')
  }

  updateExecutionType(executionType: string): void {
    this.executionType = executionType;
  }

  updateCompetences(competences: string[]): void {
    this.competences = competences;
  }

  updateStartDate(startDate: string): void {
    this.startDate = startDate;
  }

  updateEndDate(endDate: string): void {
    this.endDate = endDate;
  }

  updateInvoiceCompetence(invoiceCompetence: string): void {
    this.invoiceCompetence = invoiceCompetence;
  }

  closeDialog(): void {
    this.modalState = false;
  }

  modalTitle(): string {
    return this.simulation ? 'Simular Cálculo de Faturamento' : 'Executar Faturamento';
  }
}
